<div class="card rounded-4 w-100 shadow p-3 bg-{{ cardBgColor }} border-0">
  <img src="{{ cardIcon }}" width="80px" class="py-2" />
  <h5 class="fw-semibold py-1 fw-bold">{{ title }}</h5>
  @if (subTitle) {
    <div class="py-2 text-dark-gray">{{ subTitle }}</div>
  }
  <div class="d-flex justify-content-between">
    <span class="text-start text-dark-gray">{{ bottomLeftText }}</span>
    <span class="text-end text-dark-gray">{{ bottomRightText }}</span>
  </div>
</div>
